// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skill-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 50px;
    margin: 50px 7vw 0px 15vw;
}

.skill-container .skill-header {
    font-size: 50px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 50px;
}

.skill-container .skill-box {
    width: 100%;
}

.skill-box h2 {
    color: #fff;
    letter-spacing: 2px;
    word-spacing: 3px;
}

.skill-box .skillset {
    margin: 25px 0 50px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    gap: 10px 25px;
}

.techLogo {
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 15px;
    height: 120px;
    width: auto;
    padding: 30px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}

.skill-box .skillset abbr .techLogo:hover{
    border: 2px solid rgb(255, 255, 255);
    box-shadow: 0px 5px 20px 0px rgba(255, 255, 255, 0.4);
    transform: scale(1.15);
}

@media screen and (max-width: 1040px), (max-height: 550px) {

    .skill-container {
        margin: 50px 7vw 0px 20vw;
    }
}

@media screen and (max-width: 750px) {
    .skill-container {
        padding-top:  80px;
        margin: 0 50px 0px;
    }

    .techLogo {
        height: 80px;
        padding: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SkillCardStyle.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,qDAAqD;IACrD,sBAAsB;AAC1B;;AAEA;;IAEI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".skill-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding-top: 50px;\n    margin: 50px 7vw 0px 15vw;\n}\n\n.skill-container .skill-header {\n    font-size: 50px;\n    font-weight: 600;\n    color: #fff;\n    margin-bottom: 50px;\n}\n\n.skill-container .skill-box {\n    width: 100%;\n}\n\n.skill-box h2 {\n    color: #fff;\n    letter-spacing: 2px;\n    word-spacing: 3px;\n}\n\n.skill-box .skillset {\n    margin: 25px 0 50px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-evenly;\n    align-items: center;\n    gap: 10px 25px;\n}\n\n.techLogo {\n    border: 1px solid rgba(255, 255, 255, 0.8);\n    border-radius: 15px;\n    height: 120px;\n    width: auto;\n    padding: 30px;\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n}\n\n.skill-box .skillset abbr .techLogo:hover{\n    border: 2px solid rgb(255, 255, 255);\n    box-shadow: 0px 5px 20px 0px rgba(255, 255, 255, 0.4);\n    transform: scale(1.15);\n}\n\n@media screen and (max-width: 1040px), (max-height: 550px) {\n\n    .skill-container {\n        margin: 50px 7vw 0px 20vw;\n    }\n}\n\n@media screen and (max-width: 750px) {\n    .skill-container {\n        padding-top:  80px;\n        margin: 0 50px 0px;\n    }\n\n    .techLogo {\n        height: 80px;\n        padding: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
